const buzzwords = {
  buzzOne: [
    'grunge',
    'nirvana',
    'cuteness',
    'style',
    'class',
    'functionality',
    'lightning',
    'thunder',
    'space',
    'mornings',
    'your life',
    'classicism',
    'chai',
    'the experience',
    '2K',
    'value',
    'luxury',
    'paris',
    'brutalism',
    'existence',
    'spice',
    'you',
    'existentialism',
    'matcha',
    'tribalism',
    'the grid',
    'speed',
    'scrumptiousness',
    'autonomy',
    'conceptualism',
    'eyecandy',
  ],

  buzzTwo: [
    'refined',
    'redefined',
    'overhauled',
    'enhanced',
    'declassified',
    'revisited',
    'with bells on',
    'of yesterday',
    'of tomorrow',
    'of now',
    'personalised',
    'squared',
    'couture',
    '...but not',
    'NOW',
    'stylised',
    'serialized',
    'conceptualised',
    'unleashed',
    'inverted',
    '1995',
    'awakened',
    're-awakened',
    'forever',
    'visualised',
    'realised',
    'in a car?!',
  ],
};

export default buzzwords;
